module.exports = __webpack_public_path__ + "sideSprite-00de5684834da0f5d54b7cc09e29e171.png";